$(document).ready(function () {
	
    $(".block__pic").imagezoomsl({
        zoomrange: [3, 3]
		

    });
});
